import { render, staticRenderFns } from "./StatsCards.vue?vue&type=template&id=7b2455e9&scoped=true"
import script from "./StatsCards.vue?vue&type=script&lang=js"
export * from "./StatsCards.vue?vue&type=script&lang=js"
import style0 from "./StatsCards.vue?vue&type=style&index=0&id=7b2455e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2455e9",
  null
  
)

export default component.exports